export default [
    /*{
    id: "20301",
    name: "Fakultni Thomayerova nemocnice ",
},{
    id: "20302",
    name: "Fakultni nemocnice Ostrava",
},
*/
{
    id: "20304",
    name: "Ustredni vojenska nemocnice - Vojenska fakultni nemocnice Praha",
},
{
    id: "20303",
    name: "Fakultni nemocnice Plzen",
},
{
    id: "20301",
    name: "Fakultni Thomayerova nemocnice",   
}
 ];